import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase, InjectedStyledComponent } from '../../../../../shared/index.js';

import { IDotWrapperConfiguration, IDotWrapperProps, IDotWrapperState } from './models/index.js';
import {
	DOT_WRAPPER_CATEGORY_KEY,
	DOT_WRAPPER_COMPONENT_KEY,
	DOT_WRAPPER_PARENT_COMPONENT_KEY,
} from './DotWrapper.meta.js';

export class DotWrapper extends ComponentBase<IDotWrapperProps, IDotWrapperState, IDotWrapperConfiguration> {
	categoryKey = DOT_WRAPPER_CATEGORY_KEY;
	componentKey = DOT_WRAPPER_COMPONENT_KEY;
	assignDotsRef: HTMLElement | null | undefined;
	get parentComponentKey(): string | undefined {
		return DOT_WRAPPER_PARENT_COMPONENT_KEY;
	}

	constructor(props: IDotWrapperProps) {
		super(props);
	}

	assignReference = (instance: HTMLElement | null) => {
		const { assignDotsRef } = this.props;
		this.assignDotsRef = instance;
		if (assignDotsRef) {
			return assignDotsRef(instance);
		}
	};

	render() {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { children, assignDotsRef, configuration, ...otherProps } = this.props;

		return (
			<section {...otherProps} ref={this.assignReference}>
				{children}
			</section>
		);
	}
}

export default InjectedStyledComponent(
	observer(DotWrapper),
	DOT_WRAPPER_CATEGORY_KEY,
	DOT_WRAPPER_PARENT_COMPONENT_KEY,
	[DOT_WRAPPER_COMPONENT_KEY],
);
